module.exports = __webpack_public_path__ + "static/media/tron.e972a6fd.png";